import { Card } from "@blueprintjs/core";
import { ColorResult, SketchPicker } from 'react-color';

import { registerField, registerWidget } from "common/form/register";
import PropertyReferencePicker from "core/components/editor/properties/PropertyReferencePicker";
import { PropertyType } from "core/decorators/PropertyType";
import ColorUtil from "core/util/ColorUtil";
import StringUtil from "core/util/StringUtil";
import { IFieldProps } from "decorator-form";
import { AbstractPropertyType, PreviewDisplay } from "../../core/util/property/AbstractPropertyType";
import IPropertyRecord from "../../core/util/property/IPropertyRecord";
import ColorPickerWidget from "../form/widgets/ColorPickerWidget";
import { CssPropertyProvider, ICssProperty } from "./CssPropertyProvider";

/*
@Validate({type: ValidationTypes.NUMBER, pattern: [0.01-1]})*/
interface IColor {
	r: number;
	g: number;
	b: number;
	a?: number;
}

@PropertyType({name: "color", label: "Color"})
export default class ColorPropertyType extends AbstractPropertyType<IColor, ICssProperty> {

	public getDefaultValue() {
		return {r: 255, g: 0, b: 0, a: 0};
	}

	public getValue({r, g, b, a}: IColor): ICssProperty {
		return {
			property: "color",
			value: StringUtil.format("rgba(%s, %s, %s, %s)", r, g, b, a)
		};
	}

	public getInput(value: IColor, onChange: (value: IColor) => void,  wrapper?: IPropertyRecord<IColor>) {
		return (
			<SketchPicker color={value} onChange={(r) => onChange(r.rgb)} />
		);
	}

	public getPreviewElement(value: IColor, minimal: boolean, wrapper: IPropertyRecord<IColor>) {
		return (
			<Card style={{
				background: this.getValue(value).value,
				padding: "5px"
			}}>
				<span style={{color: ColorUtil.invertColor(value, true)}}>{wrapper.displayName}</span>
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/theme/CssColorProperty.type.tsx